class JsPlatform: Platform {
    override val name: String = model.Platform.WEBJS.name
}

actual fun getPlatform(): Platform = JsPlatform()